import { ILaya } from "../../ILaya";
import { HideFlags } from "../Const";
import { Event } from "../events/Event";
import { InputManager } from "../events/InputManager";
import { SerializeUtil } from "../loaders/SerializeUtil";
import { MathUtil } from "../maths/MathUtil";
import { Point } from "../maths/Point";
import { Rectangle } from "../maths/Rectangle";
import { Tween } from "../tween/Tween";
import { SpriteUtils } from "../utils/SpriteUtils";
import { LayoutType, ScrollBarDisplay, ScrollBounceBackEffect, ScrollDirection, ScrollTouchEffect } from "./Const";
import { UIConfig2 } from "./UIConfig";
import { GWidget } from "./GWidget";
import { ListLayout } from "./layout/ListLayout";
import { UIEvent } from "./UIEvent";
import { DragSupport } from "../utils/DragSupport";
var s_Point = new Point();
var s_rect = new Rectangle();
var s_rect2 = new Rectangle();
var s_endPos = new Point();
var s_oldChange = new Point();
var s_gestureFlag = 0;
const TWEEN_TIME_GO = 0.5;
const TWEEN_TIME_DEFAULT = 0.3;
const PULL_RATIO = 0.5;
var draggingInst;
export class Scroller {
    constructor() {
        this._dir = 0;
        this._step = 0;
        this._decelerationRate = 0;
        this._barDisplay = 0;
        this._barDisplay2 = 0;
        this._touchEffect2 = 0;
        this._bouncebackEffect2 = 0;
        this._touchEffectButton = 0;
        this._xPos = 0;
        this._yPos = 0;
        this._aniFlag = 0;
        this._headerLockedSize = 0;
        this._footerLockedSize = 0;
        this._tweening = 0;
        this._loop = 0;
        this._barMargin = [0, 0, 0, 0];
        this._viewSize = new Point();
        this._contentSize = new Point();
        this._pageSize = new Point(1, 1);
        this._overlapSize = new Point();
        this._tweenTime = new Point();
        this._tweenStart = new Point();
        this._tweenDuration = new Point();
        this._tweenChange = new Point();
        this._slidingPoints = [];
        this._containerPos = new Point();
        this._beginTouchPos = new Point();
        this._cachedScrollRect = new Rectangle();
        this._step = UIConfig2.defaultScrollStep;
        this._decelerationRate = UIConfig2.defaultScrollDecelerationRate;
        this._barDisplay = UIConfig2.defaultScrollBarDisplay;
        this._touchEffect = UIConfig2.defaultScrollTouchEffect;
        this._bouncebackEffect = UIConfig2.defaultScrollTouchEffect;
    }
    get owner() {
        return this._owner;
    }
    set owner(value) {
        if (this._owner == value)
            return;
        if (this._owner) {
            this._owner.offAllCaller(this);
            if (this._tweening !== 0)
                ILaya.timer.clear(this, this.tweenUpdate);
            if (this._hScrollBar) {
                this._hScrollBar.destroy();
                this._hScrollBar = null;
            }
            if (this._vScrollBar) {
                this._vScrollBar.destroy();
                this._vScrollBar = null;
            }
            if (this._header) {
                this._header.destroy();
                this._header = null;
            }
            if (this._footer) {
                this._footer.destroy();
                this._footer = null;
            }
            this._container.pos(0, 0);
            this._owner.setLayoutChangedFlag();
        }
        this._owner = value;
        if (value) {
            this._layout = value.layout;
            this._container = value._$container;
            this._maskContainer = this._container.parent;
            this._container.pos(0, 0);
            if (!SerializeUtil.isDeserializing) {
                value.clipping = true;
                this._setDefaultDirection();
            }
            this.createHzScrollBar();
            this.createVtScrollBar();
            value.on(Event.MOUSE_DOWN, this, this._touchBegin);
            value.on(Event.MOUSE_WHEEL, this, this._mouseWheel);
            value.on(Event.ROLL_OVER, this, this._rollOver);
            value.on(Event.ROLL_OUT, this, this._rollOut);
            value.setLayoutChangedFlag();
            this._processClipping();
            this._ownerSizeChanged();
        }
    }
    destroy() {
        this.owner = null;
    }
    get hScrollBar() {
        return this._hScrollBar;
    }
    get vScrollBar() {
        return this._vScrollBar;
    }
    get header() {
        return this._header;
    }
    get footer() {
        return this._footer;
    }
    get hScrollBarRes() {
        return this._hScrollBarRes;
    }
    set hScrollBarRes(value) {
        this._hScrollBarRes = value;
        this.createHzScrollBar(true);
    }
    get vScrollBarRes() {
        return this._vScrollBarRes;
    }
    set vScrollBarRes(value) {
        this._vScrollBarRes = value;
        this.createVtScrollBar(true);
    }
    get headerRes() {
        return this._headerRes;
    }
    set headerRes(value) {
        this._headerRes = value;
        this.createHeader();
    }
    get footerRes() {
        return this._footerRes;
    }
    set footerRes(value) {
        this._footerRes = value;
        this.createFooter();
    }
    get direction() {
        return this._dir;
    }
    set direction(value) {
        if (this._dir !== value) {
            this._dir = value;
            if (this._refreshBarAxis != null)
                this._refreshBarAxis = (this._dir === ScrollDirection.Both || this._dir === ScrollDirection.Vertical) ? "y" : "x";
            this.createHzScrollBar();
            this.createVtScrollBar();
        }
    }
    get barDisplay() {
        return this._barDisplay2;
    }
    set barDisplay(value) {
        if (this._barDisplay2 !== value) {
            this._barDisplay2 = value;
            this._barDisplay = value === ScrollBarDisplay.Default ? UIConfig2.defaultScrollBarDisplay : value;
            this.createHzScrollBar();
            this.createVtScrollBar();
        }
    }
    get barOnLeft() {
        return this._barOnLeft;
    }
    set barOnLeft(value) {
        if (this._barOnLeft != value) {
            this._barOnLeft = value;
            this.onSizeChanged();
        }
    }
    get barFloating() {
        return this._barFloating;
    }
    set barFloating(value) {
        if (this._barFloating != value) {
            this._barFloating = value;
            this.onSizeChanged();
        }
    }
    get barMargin() {
        return this._barMargin;
    }
    set barMargin(value) {
        if (value == null || !Array.isArray(value))
            value = [0, 0, 0, 0];
        this._barMargin = value;
        this.onSizeChanged();
    }
    get bouncebackEffect() {
        return this._bouncebackEffect2;
    }
    set bouncebackEffect(value) {
        this._bouncebackEffect2 = value;
        if (value === ScrollBounceBackEffect.Default)
            this._bouncebackEffect = UIConfig2.defaultScrollBounceEffect;
        else
            this._bouncebackEffect = value == ScrollBounceBackEffect.On;
    }
    get touchEffect() {
        return this._touchEffect2;
    }
    set touchEffect(value) {
        this._touchEffect2 = value;
        if (value === ScrollTouchEffect.Default)
            this._touchEffect = UIConfig2.defaultScrollTouchEffect;
        else
            this._touchEffect = value === ScrollTouchEffect.On;
    }
    get touchEffectButton() {
        return this._touchEffectButton;
    }
    set touchEffectButton(value) {
        this._touchEffectButton = value;
    }
    get pageMode() {
        return this._pageMode;
    }
    set pageMode(value) {
        this._pageMode = value;
    }
    set step(value) {
        this._step = value;
    }
    get step() {
        return this._step;
    }
    get snapToItem() {
        return this._snapToItem;
    }
    set snapToItem(value) {
        this._snapToItem = value;
    }
    get inertiaDisabled() {
        return this._inertiaDisabled;
    }
    set inertiaDisabled(value) {
        this._inertiaDisabled = value;
    }
    get paddingMaskDisabled() {
        return this._paddingMaskDisabled;
    }
    set paddingMaskDisabled(value) {
        if (this._paddingMaskDisabled != value) {
            this._paddingMaskDisabled = value;
            this._processClipping();
        }
    }
    get mouseWheelDisabled() {
        return this._mouseWheelDisabled;
    }
    set mouseWheelDisabled(value) {
        this._mouseWheelDisabled = value;
    }
    get decelerationRate() {
        return this._decelerationRate;
    }
    set decelerationRate(value) {
        this._decelerationRate = value;
    }
    get isDragged() {
        return this._dragged;
    }
    get percX() {
        return this._overlapSize.x === 0 ? 0 : this._xPos / this._overlapSize.x;
    }
    set percX(value) {
        this.setPercX(value, false);
    }
    setPercX(value, ani) {
        this._layout.refresh();
        this.setPosX(this._overlapSize.x * MathUtil.clamp01(value), ani);
    }
    get percY() {
        return this._overlapSize.y === 0 ? 0 : this._yPos / this._overlapSize.y;
    }
    set percY(value) {
        this.setPercY(value, false);
    }
    setPercY(value, ani) {
        this._layout.refresh();
        this.setPosY(this._overlapSize.y * MathUtil.clamp01(value), ani);
    }
    get posX() {
        return this._xPos;
    }
    set posX(value) {
        this.setPosX(value, false);
    }
    setPosX(value, ani) {
        this._layout.refresh();
        if (this._loop === 1)
            value = this.loopCheckingNewPos(value, "x");
        value = MathUtil.clamp(value, 0, this._overlapSize.x);
        if (value !== this._xPos) {
            this._xPos = value;
            this.posChanged(ani);
        }
    }
    get posY() {
        return this._yPos;
    }
    set posY(value) {
        this.setPosY(value, false);
    }
    setPosY(value, ani) {
        this._layout.refresh();
        if (this._loop === 1)
            value = this.loopCheckingNewPos(value, "y");
        value = MathUtil.clamp(value, 0, this._overlapSize.y);
        if (value !== this._yPos) {
            this._yPos = value;
            this.posChanged(ani);
        }
    }
    get contentWidth() {
        return this._contentSize.x;
    }
    get contentHeight() {
        return this._contentSize.y;
    }
    get viewWidth() {
        return this._viewSize.x;
    }
    get viewHeight() {
        return this._viewSize.y;
    }
    setViewSize(width, height) {
        width = width + this._layout.padding[3] + this._layout.padding[1];
        if (this._vScrollBar && !this._barFloating)
            width += this._vScrollBar.width;
        height = height + this._layout.padding[0] + this._layout.padding[2];
        if (this._hScrollBar && !this._barFloating)
            height += this._hScrollBar.height;
        this._owner.size(width, height);
    }
    get pageX() {
        if (!this._pageMode)
            return 0;
        let page = Math.floor(this._xPos / this._pageSize.x);
        if (this._xPos - page * this._pageSize.x > this._pageSize.x * 0.5)
            page++;
        return page;
    }
    set pageX(value) {
        this.setPageX(value, false);
    }
    get pageY() {
        if (!this._pageMode)
            return 0;
        let page = Math.floor(this._yPos / this._pageSize.y);
        if (this._yPos - page * this._pageSize.y > this._pageSize.y * 0.5)
            page++;
        return page;
    }
    set pageY(value) {
        this.setPageY(value, false);
    }
    setPageX(value, ani) {
        if (!this._pageMode)
            return;
        this._layout.refresh();
        if (this._overlapSize.x > 0)
            this.setPosX(value * this._pageSize.x, ani);
    }
    setPageY(value, ani) {
        if (!this._pageMode)
            return;
        this._layout.refresh();
        if (this._overlapSize.y > 0)
            this.setPosY(value * this._pageSize.y, ani);
    }
    get pageCountX() {
        return Math.ceil(this._contentSize.x / this._viewSize.x);
    }
    get pageCountY() {
        return Math.ceil(this._contentSize.y / this._viewSize.y);
    }
    get isBottomMost() {
        return this._yPos === this._overlapSize.y || this._overlapSize.y === 0;
    }
    get isRightMost() {
        return this._xPos === this._overlapSize.x || this._overlapSize.x === 0;
    }
    get scrollingPosX() {
        return MathUtil.clamp(-this._container.x, 0, this._overlapSize.x);
    }
    get scrollingPosY() {
        return MathUtil.clamp(-this._container.y, 0, this._overlapSize.y);
    }
    scrollTop(ani) {
        this.setPercY(0, ani);
    }
    scrollBottom(ani) {
        this.setPercY(1, ani);
    }
    scrollUp(ratio, ani) {
        ratio = ratio || 1;
        if (this._pageMode)
            this.setPosY(this._yPos - this._pageSize.y * ratio, ani);
        else
            this.setPosY(this._yPos - this._step * ratio, ani);
        ;
    }
    scrollDown(ratio, ani) {
        ratio = ratio || 1;
        if (this._pageMode)
            this.setPosY(this._yPos + this._pageSize.y * ratio, ani);
        else
            this.setPosY(this._yPos + this._step * ratio, ani);
    }
    scrollLeft(ratio, ani) {
        ratio = ratio || 1;
        if (this._pageMode)
            this.setPosX(this._xPos - this._pageSize.x * ratio, ani);
        else
            this.setPosX(this._xPos - this._step * ratio, ani);
    }
    scrollRight(ratio, ani) {
        ratio = ratio || 1;
        if (this._pageMode)
            this.setPosX(this._xPos + this._pageSize.x * ratio, ani);
        else
            this.setPosX(this._xPos + this._step * ratio, ani);
    }
    getRect(target, rect) {
        if (target._parent != this._owner._$container)
            SpriteUtils.transformRect(target._parent, rect.setTo(target.x, target.y, target.width, target.height), this._owner._$container, rect);
        else
            rect.setTo(target.x, target.y, target.width, target.height);
        return rect;
    }
    scrollTo(target, ani, setFirst) {
        this._layout.refresh();
        if (this._needRefresh)
            this.refresh();
        let rect;
        if (typeof (target) === "number") {
            if ((this._layout instanceof ListLayout) && this._layout._virtual)
                target = this._layout.getRectByItemIndex(target);
            else
                target = this._owner.getChildAt(target);
        }
        if (target instanceof Rectangle)
            rect = target;
        else if (target.parent == null)
            return;
        else
            rect = this.getRect(target, s_rect);
        let setFirstX, setFirstY;
        if (setFirst instanceof GWidget) {
            if (setFirst != target && setFirst.parent != null) {
                let rect2 = this.getRect(setFirst, s_rect2);
                if (this._overlapSize.x > 0 && rect.right - rect2.x > this._viewSize.x) {
                    rect.x = rect2.x;
                    rect.width = rect2.width;
                    setFirstX = true;
                }
                if (this._overlapSize.y > 0 && rect.bottom - rect2.y > this._viewSize.y) {
                    rect.y = rect2.y;
                    rect.height = rect2.height;
                    setFirstY = true;
                }
            }
            else
                setFirstX = setFirstY = false;
        }
        else
            setFirstX = setFirstY = !!setFirst;
        if (this._overlapSize.y > 0) {
            let bottom = this._yPos + this._viewSize.y;
            if (setFirstX || rect.y <= this._yPos) {
                if (!setFirstX && rect.y + rect.height >= bottom)
                    return;
                if (this._pageMode)
                    this.setPosY(Math.floor(rect.y / this._pageSize.y) * this._pageSize.y, ani);
                else
                    this.setPosY(rect.y, ani);
            }
            else if (rect.y + rect.height > bottom) {
                if (this._pageMode)
                    this.setPosY(Math.floor(rect.y / this._pageSize.y) * this._pageSize.y, ani);
                else if (rect.height <= this._viewSize.y / 2)
                    this.setPosY(rect.y + rect.height * 2 - this._viewSize.y, ani);
                else
                    this.setPosY(rect.y + Math.min(rect.height - this._viewSize.y, 0), ani);
            }
        }
        if (this._overlapSize.x > 0) {
            let right = this._xPos + this._viewSize.x;
            if (setFirstY || rect.x <= this._xPos) {
                if (!setFirstY && rect.x + rect.width >= right)
                    return;
                if (this._pageMode)
                    this.setPosX(Math.floor(rect.x / this._pageSize.x) * this._pageSize.x, ani);
                else
                    this.setPosX(rect.x, ani);
            }
            else if (rect.x + rect.width > right) {
                if (this._pageMode)
                    this.setPosX(Math.floor(rect.x / this._pageSize.x) * this._pageSize.x, ani);
                else if (rect.width <= this._viewSize.x / 2)
                    this.setPosX(rect.x + rect.width * 2 - this._viewSize.x, ani);
                else
                    this.setPosX(rect.x + Math.min(rect.width - this._viewSize.x, 0), ani);
            }
        }
        if (!ani && this._needRefresh)
            this.refresh();
    }
    isChildInView(obj) {
        if (this._overlapSize.y > 0) {
            let dist = obj.top + this._container.y;
            if (dist < -obj.height || dist > this._viewSize.y)
                return false;
        }
        if (this._overlapSize.x > 0) {
            let dist = obj.left + this._container.x;
            if (dist < -obj.width || dist > this._viewSize.x)
                return false;
        }
        return true;
    }
    getFirstChildInView() {
        let i = 0;
        for (let child of this._owner.children) {
            if (child._nodeType === 2 && this.isChildInView(child))
                return i;
            i++;
        }
        return -1;
    }
    cancelDragging() {
        ILaya.stage.off(Event.MOUSE_MOVE, this, this._touchMove);
        ILaya.stage.off(Event.MOUSE_UP, this, this._touchEnd);
        if (draggingInst == this)
            draggingInst = null;
        s_gestureFlag = 0;
        this._dragged = false;
    }
    _setDefaultDirection() {
        let layout = this._layout;
        if (layout.pageMode)
            return;
        if (layout.type === LayoutType.SingleColumn || layout.type === LayoutType.FlowX)
            this.direction = ScrollDirection.Vertical;
        else if (layout.type === LayoutType.SingleRow || layout.type === LayoutType.FlowY)
            this.direction = ScrollDirection.Horizontal;
    }
    createVtScrollBar(force) {
        if (!this._owner)
            return;
        if (force) {
            let inst = this._vScrollBar;
            this._vScrollBar = null;
            this.createVtScrollBar();
            if (inst && inst !== this._vScrollBar) {
                inst.destroy();
                this.onSizeChanged();
            }
            return;
        }
        if (this._barDisplay !== ScrollBarDisplay.Hidden && (this._dir === ScrollDirection.Both || this._dir === ScrollDirection.Vertical)) {
            if (this._vScrollBar)
                return;
            let res = this._vScrollBarRes ? this._vScrollBarRes : (UIConfig2.verticalScrollBar ? ILaya.loader.getRes(UIConfig2.verticalScrollBar) : null);
            if (res) {
                this._vScrollBar = res.create();
                if (!this._vScrollBar) {
                    console.warn("failed to create a vertical scrollbar");
                    return;
                }
                this._vScrollBar.hideFlags |= HideFlags.HideAndDontSave;
                this._vScrollBar.setOwner(this, true);
                this._vScrollBar.visible = this._barDisplay !== ScrollBarDisplay.OnScroll;
                this._owner._addChild(this._vScrollBar);
                this.onSizeChanged();
            }
        }
        else if (this._vScrollBar) {
            this._vScrollBar.destroy();
            this._vScrollBar = null;
            this.onSizeChanged();
        }
    }
    createHzScrollBar(force) {
        if (!this._owner)
            return;
        if (force) {
            let inst = this._hScrollBar;
            this._hScrollBar = null;
            this.createHzScrollBar();
            if (inst && inst !== this._hScrollBar) {
                inst.destroy();
                this.onSizeChanged();
            }
        }
        if (this._barDisplay !== ScrollBarDisplay.Hidden && (this._dir === ScrollDirection.Both || this._dir === ScrollDirection.Horizontal)) {
            if (this._hScrollBar)
                return;
            let res = this._hScrollBarRes ? this._hScrollBarRes : (UIConfig2.horizontalScrollBar ? ILaya.loader.getRes(UIConfig2.horizontalScrollBar) : null);
            if (res) {
                this._hScrollBar = res.create();
                if (!this._hScrollBar) {
                    console.warn("failed to create a horizontal scrollbar");
                    return;
                }
                this._hScrollBar.hideFlags |= HideFlags.HideAndDontSave;
                this._hScrollBar.setOwner(this, false);
                this._hScrollBar.visible = this._barDisplay !== ScrollBarDisplay.OnScroll;
                this._owner._addChild(this._hScrollBar);
                this.onSizeChanged();
            }
        }
        else if (this._hScrollBar) {
            this._hScrollBar.destroy();
            this._hScrollBar = null;
            this.onSizeChanged();
        }
    }
    createHeader() {
        if (this._header) {
            this._header.destroy();
            this._header = null;
        }
        if (this._headerRes) {
            this._header = this._headerRes.create();
            if (this._header)
                this._header.hideFlags |= HideFlags.HideAndDontSave;
        }
        if (this._header || this._footer)
            this._refreshBarAxis = (this._dir === ScrollDirection.Both || this._dir === ScrollDirection.Vertical) ? "y" : "x";
        else
            this._refreshBarAxis = null;
    }
    createFooter() {
        if (this._footer) {
            this._footer.destroy();
            this._footer = null;
        }
        if (this._footerRes) {
            this._footer = this._footerRes.create();
            if (this._footer)
                this._footer.hideFlags |= HideFlags.HideAndDontSave;
        }
        if (this._header || this._footer)
            this._refreshBarAxis = (this._dir === ScrollDirection.Both || this._dir === ScrollDirection.Vertical) ? "y" : "x";
        else
            this._refreshBarAxis = null;
    }
    lockHeader(size) {
        if (this._headerLockedSize === size)
            return;
        this._headerLockedSize = size;
        if (!this._refreshEventDispatching && this._container[this._refreshBarAxis] >= 0) {
            this._tweenStart.setTo(this._container.x, this._container.y);
            this._tweenChange.setTo(0, 0);
            this._tweenChange[this._refreshBarAxis] = this._headerLockedSize - this._tweenStart[this._refreshBarAxis];
            this._tweenDuration.setTo(TWEEN_TIME_DEFAULT, TWEEN_TIME_DEFAULT);
            this.startTween(2);
        }
    }
    lockFooter(size) {
        if (this._footerLockedSize === size)
            return;
        this._footerLockedSize = size;
        if (!this._refreshEventDispatching && this._container[this._refreshBarAxis] <= -this._overlapSize[this._refreshBarAxis]) {
            this._tweenStart.setTo(this._container.x, this._container.y);
            this._tweenChange.setTo(0, 0);
            let max = this._overlapSize[this._refreshBarAxis];
            if (max === 0)
                max = Math.max(this._contentSize[this._refreshBarAxis] + this._footerLockedSize - this._viewSize[this._refreshBarAxis], 0);
            else
                max += this._footerLockedSize;
            this._tweenChange[this._refreshBarAxis] = -max - this._tweenStart[this._refreshBarAxis];
            this._tweenDuration.setTo(TWEEN_TIME_DEFAULT, TWEEN_TIME_DEFAULT);
            this.startTween(2);
        }
    }
    _shouldCheckOverflow() {
        if (this._barDisplay === ScrollBarDisplay.OnOverflow || this._barDisplay === ScrollBarDisplay.OnOverflowAndScroll)
            return (this._vScrollBar != null ? 1 : 0) + (this._hScrollBar != null ? 2 : 0);
        else
            return null;
    }
    _processClipping() {
        if (this._owner)
            this._maskContainer.scrollRect = (!this._paddingMaskDisabled && this._owner.clipping) ? this._cachedScrollRect : null;
    }
    _ownerSizeChanged() {
        this.onSizeChanged();
        this.posChanged(false);
    }
    onSizeChanged() {
        var _a, _b, _c;
        if (!this._owner)
            return;
        let aWidth = this._owner.width;
        let aHeight = this._owner.height;
        let padding = this._layout.padding;
        let mx, my;
        if (this._barOnLeft && this._vScrollBar && !this._barFloating)
            mx = Math.floor(padding[3] + this._vScrollBar.width);
        else
            mx = Math.floor(padding[3]);
        my = Math.floor(padding[0]);
        this._maskContainer.pos(mx, my);
        if (this._hScrollBar) {
            this._hScrollBar.pos(this._barMargin[3] + (this._barOnLeft ? (((_a = this._vScrollBar) === null || _a === void 0 ? void 0 : _a.width) || 0) : 0), aHeight - this._hScrollBar.height - this._barMargin[2]);
            this._hScrollBar.width = aWidth - (((_b = this._vScrollBar) === null || _b === void 0 ? void 0 : _b.width) || 0) - this._barMargin[3] - this._barMargin[1];
        }
        if (this._vScrollBar) {
            this._vScrollBar.pos(this._barOnLeft ? this._barMargin[3] : aWidth - this._vScrollBar.width - this._barMargin[1], this._barMargin[0]);
            this._vScrollBar.height = aHeight - (((_c = this._hScrollBar) === null || _c === void 0 ? void 0 : _c.height) || 0) - this._barMargin[0] - this._barMargin[2];
        }
        this._viewSize.x = aWidth;
        this._viewSize.y = aHeight;
        if (this._hScrollBar && !this._barFloating)
            this._viewSize.y -= this._hScrollBar.height;
        if (this._vScrollBar && !this._barFloating)
            this._viewSize.x -= this._vScrollBar.width;
        this._viewSize.x -= (padding[3] + padding[1]);
        this._viewSize.y -= (padding[0] + padding[2]);
        this._viewSize.x = Math.max(1, this._viewSize.x);
        this._viewSize.y = Math.max(1, this._viewSize.y);
        this._pageSize.x = this._viewSize.x;
        this._pageSize.y = this._viewSize.y;
        this.onContentSizeChanged();
    }
    _ownerContentSizeChanged() {
        let aWidth = this._layout.contentWidth;
        let aHeight = this._layout.contentHeight;
        if (this._contentSize.x === aWidth && this._contentSize.y === aHeight)
            return;
        this._contentSize.x = aWidth;
        this._contentSize.y = aHeight;
        this.onContentSizeChanged();
    }
    _changeContentSizeOnScrolling(deltaWidth, deltaHeight, deltaPosX, deltaPosY) {
        let isRightmost = this._xPos !== 0 && this._xPos === this._overlapSize.x;
        let isBottom = this._yPos !== 0 && this._yPos === this._overlapSize.y;
        this._contentSize.x += deltaWidth;
        this._contentSize.y += deltaHeight;
        this.onContentSizeChanged();
        if (this._tweening === 1) {
            if (deltaWidth !== 0 && isRightmost && this._tweenChange.x < 0) {
                this._xPos = this._overlapSize.x;
                this._tweenChange.x = -this._xPos - this._tweenStart.x;
            }
            if (deltaHeight !== 0 && isBottom && this._tweenChange.y < 0) {
                this._yPos = this._overlapSize.y;
                this._tweenChange.y = -this._yPos - this._tweenStart.y;
            }
        }
        else if (this._tweening === 2) {
            if (deltaPosX !== 0) {
                this._container.x -= deltaPosX;
                this._tweenStart.x -= deltaPosX;
                this._xPos = -this._container.x;
            }
            if (deltaPosY !== 0) {
                this._container.y -= deltaPosY;
                this._tweenStart.y -= deltaPosY;
                this._yPos = -this._container.y;
            }
        }
        else if (this._dragged) {
            if (deltaPosX !== 0) {
                this._container.x -= deltaPosX;
                this._containerPos.x -= deltaPosX;
                this._xPos = -this._container.x;
            }
            if (deltaPosY !== 0) {
                this._container.y -= deltaPosY;
                this._containerPos.y -= deltaPosY;
                this._yPos = -this._container.y;
            }
        }
        else {
            if (deltaWidth !== 0 && isRightmost) {
                this._xPos = this._overlapSize.x;
                this._container.x = -this._xPos;
            }
            if (deltaHeight !== 0 && isBottom) {
                this._yPos = this._overlapSize.y;
                this._container.y = -this._yPos;
            }
        }
    }
    onContentSizeChanged() {
        if (!this._owner)
            return;
        if (this._barDisplay === ScrollBarDisplay.OnOverflow || this._barDisplay === ScrollBarDisplay.OnOverflowAndScroll) {
            this._vScrollNone = this._contentSize.y <= this._viewSize.y;
            this._hScrollNone = this._contentSize.x <= this._viewSize.x;
            if (this._vScrollBar && this._hScrollBar) {
                if (!this._hScrollNone)
                    this._vScrollBar.height = this._owner.height - this._hScrollBar.height - this._barMargin[0] - this._barMargin[2];
                else
                    this._vScrollBar.height = this._owner.height - this._barMargin[0] - this._barMargin[2];
                if (!this._vScrollNone)
                    this._hScrollBar.width = this._owner.width - this._vScrollBar.width - this._barMargin[3] - this._barMargin[1];
                else
                    this._hScrollBar.width = this._owner.width - this._barMargin[3] - this._barMargin[1];
            }
        }
        if (this._vScrollBar) {
            if (this._contentSize.y === 0)
                this._vScrollBar.setDisplayPerc(0);
            else
                this._vScrollBar.setDisplayPerc(Math.min(1, this._viewSize.y / this._contentSize.y));
        }
        if (this._hScrollBar) {
            if (this._contentSize.x === 0)
                this._hScrollBar.setDisplayPerc(0);
            else
                this._hScrollBar.setDisplayPerc(Math.min(1, this._viewSize.x / this._contentSize.x));
        }
        this._updateScrollBarVisible();
        let mw = this._viewSize.x;
        let mh = this._viewSize.y;
        if (this._vScrollNone && this._vScrollBar != null)
            mw += this._vScrollBar.width;
        if (this._hScrollNone && this._hScrollBar != null)
            mh += this._hScrollBar.height;
        this._maskContainer.size(mw, mh);
        this._cachedScrollRect.setTo(0, 0, mw, mh);
        if (this._maskContainer._scrollRect != null)
            this._maskContainer.scrollRect = this._cachedScrollRect;
        if (this._dir === ScrollDirection.Horizontal || this._dir === ScrollDirection.Both)
            this._overlapSize.x = Math.ceil(Math.max(0, this._contentSize.x - this._viewSize.x));
        else
            this._overlapSize.x = 0;
        if (this._dir === ScrollDirection.Vertical || this._dir === ScrollDirection.Both)
            this._overlapSize.y = Math.ceil(Math.max(0, this._contentSize.y - this._viewSize.y));
        else
            this._overlapSize.y = 0;
        this._xPos = MathUtil.clamp(this._xPos, 0, this._overlapSize.x);
        this._yPos = MathUtil.clamp(this._yPos, 0, this._overlapSize.y);
        if (this._refreshBarAxis) {
            let max = this._overlapSize[this._refreshBarAxis];
            if (max === 0)
                max = Math.max(this._contentSize[this._refreshBarAxis] + this._footerLockedSize - this._viewSize[this._refreshBarAxis], 0);
            else
                max += this._footerLockedSize;
            if (this._refreshBarAxis == "x") {
                this._container.pos(MathUtil.clamp(this._container.x, -max, this._headerLockedSize), MathUtil.clamp(this._container.y, -this._overlapSize.y, 0));
            }
            else {
                this._container.pos(MathUtil.clamp(this._container.x, -this._overlapSize.x, 0), MathUtil.clamp(this._container.y, -max, this._headerLockedSize));
            }
            if (this._header) {
                if (this._refreshBarAxis == "x")
                    this._header.height = this._viewSize.y;
                else
                    this._header.width = this._viewSize.x;
            }
            if (this._footer) {
                if (this._refreshBarAxis == "x")
                    this._footer.height = this._viewSize.y;
                else
                    this._footer.width = this._viewSize.x;
            }
        }
        else {
            this._container.pos(MathUtil.clamp(this._container.x, -this._overlapSize.x, 0), MathUtil.clamp(this._container.y, -this._overlapSize.y, 0));
        }
        this.updateScrollBarPos();
    }
    posChanged(ani) {
        if (this._aniFlag === 0)
            this._aniFlag = ani ? 1 : -1;
        else if (this._aniFlag === 1 && !ani)
            this._aniFlag = -1;
        this._needRefresh = true;
        ILaya.timer.callLater(this, this.refresh);
    }
    refresh() {
        if (this._owner == null)
            return;
        this._needRefresh = false;
        ILaya.timer.clear(this, this.refresh);
        if (this._pageMode || this._snapToItem) {
            s_endPos.setTo(-this._xPos, -this._yPos);
            this.alignPosition(s_endPos, false);
            this._xPos = -s_endPos.x;
            this._yPos = -s_endPos.y;
        }
        this.refresh2();
        this._owner.event(UIEvent.Scroll);
        if (this._needRefresh) {
            this._needRefresh = false;
            ILaya.timer.clear(this, this.refresh);
            this.refresh2();
        }
        this.updateScrollBarPos();
        this._aniFlag = 0;
    }
    refresh2() {
        if (this._aniFlag === 1 && !this._dragged) {
            let posX;
            let posY;
            if (this._overlapSize.x > 0)
                posX = -Math.floor(this._xPos);
            else {
                if (this._container.x !== 0)
                    this._container.x = 0;
                posX = 0;
            }
            if (this._overlapSize.y > 0)
                posY = -Math.floor(this._yPos);
            else {
                if (this._container.y !== 0)
                    this._container.y = 0;
                posY = 0;
            }
            if (posX !== this._container.x || posY !== this._container.y) {
                this._tweenDuration.setTo(TWEEN_TIME_GO, TWEEN_TIME_GO);
                this._tweenStart.setTo(this._container.x, this._container.y);
                this._tweenChange.setTo(posX - this._tweenStart.x, posY - this._tweenStart.y);
                this.startTween(1);
            }
            else if (this._tweening !== 0)
                this.killTween();
        }
        else {
            if (this._tweening !== 0)
                this.killTween();
            this._container.pos(Math.floor(-this._xPos), Math.floor(-this._yPos));
            this.loopCheckingCurrent();
        }
    }
    _touchBegin(evt) {
        if (!this._touchEffect || this._touchEffectButton !== evt.button)
            return;
        if (this._tweening !== 0) {
            this.killTween();
            InputManager.cancelClick(evt.touchId);
            this._dragged = true;
        }
        else
            this._dragged = false;
        let pt = this._owner.parent.globalToLocal(s_Point.copy(evt.touchPos));
        this._containerPos.setTo(this._container.x, this._container.y);
        this._beginTouchPos.setTo(pt.x, pt.y);
        this._isHoldAreaDone = false;
        this._slidingPoints.length = 0;
        this._slidingPoints.push(pt.x, pt.y, performance.now());
        ILaya.stage.on(Event.MOUSE_MOVE, this, this._touchMove);
        ILaya.stage.on(Event.MOUSE_UP, this, this._touchEnd);
    }
    _touchMove(evt) {
        var _a;
        if (!this._touchEffect || this.owner.destroyed)
            return;
        if (((_a = draggingInst === null || draggingInst === void 0 ? void 0 : draggingInst.owner) === null || _a === void 0 ? void 0 : _a.displayedInStage) && draggingInst != this)
            return;
        let sensitivity = UIConfig2.touchScrollSensitivity;
        let pt = this._owner.parent.globalToLocal(s_Point.copy(evt.touchPos));
        let offsetX = pt.x - this._slidingPoints[this._slidingPoints.length - 3];
        let offsetY = pt.y - this._slidingPoints[this._slidingPoints.length - 2];
        let diff;
        let sv, sh;
        if (this._dir === ScrollDirection.Vertical) {
            if (!this._isHoldAreaDone) {
                s_gestureFlag |= 1;
                diff = Math.abs(offsetY);
                if (diff < sensitivity)
                    return;
                if ((s_gestureFlag & 2) !== 0) {
                    let diff2 = Math.abs(offsetX);
                    if (diff < diff2)
                        return;
                }
            }
            sv = true;
        }
        else if (this._dir === ScrollDirection.Horizontal) {
            if (!this._isHoldAreaDone) {
                s_gestureFlag |= 2;
                diff = Math.abs(offsetX);
                if (diff < sensitivity)
                    return;
                if ((s_gestureFlag & 1) !== 0) {
                    let diff2 = Math.abs(offsetY);
                    if (diff < diff2)
                        return;
                }
            }
            sh = true;
        }
        else {
            s_gestureFlag = 3;
            if (!this._isHoldAreaDone) {
                diff = Math.abs(offsetY);
                if (diff < sensitivity) {
                    diff = Math.abs(offsetX);
                    if (diff < sensitivity)
                        return;
                }
            }
            sv = sh = true;
        }
        let newPosX = Math.floor(this._containerPos.x + pt.x - this._beginTouchPos.x);
        let newPosY = Math.floor(this._containerPos.y + pt.y - this._beginTouchPos.y);
        if (sv) {
            if (newPosY > 0) {
                if (!this._bouncebackEffect)
                    this._container.y = 0;
                else
                    this._container.y = Math.floor(Math.min(newPosY * 0.5, this._viewSize.y * PULL_RATIO));
            }
            else if (newPosY < -this._overlapSize.y) {
                if (!this._bouncebackEffect)
                    this._container.y = -this._overlapSize.y;
                else
                    this._container.y = Math.floor(Math.max((newPosY + this._overlapSize.y) * 0.5, -this._viewSize.y * PULL_RATIO) - this._overlapSize.y);
            }
            else
                this._container.y = newPosY;
        }
        if (sh) {
            if (newPosX > 0) {
                if (!this._bouncebackEffect)
                    this._container.x = 0;
                else
                    this._container.x = Math.floor(Math.min(newPosX * 0.5, this._viewSize.x * PULL_RATIO));
            }
            else if (newPosX < 0 - this._overlapSize.x) {
                if (!this._bouncebackEffect)
                    this._container.x = -this._overlapSize.x;
                else
                    this._container.x = Math.floor(Math.max((newPosX + this._overlapSize.x) * 0.5, -this._viewSize.x * PULL_RATIO) - this._overlapSize.x);
            }
            else
                this._container.x = newPosX;
        }
        let now = performance.now();
        while (this._slidingPoints.length > 0 && this._slidingPoints[2] < now - 100)
            this._slidingPoints.splice(0, 3);
        this._slidingPoints.push(pt.x, pt.y, now);
        if (this._overlapSize.x > 0)
            this._xPos = MathUtil.clamp(-this._container.x, 0, this._overlapSize.x);
        if (this._overlapSize.y > 0)
            this._yPos = MathUtil.clamp(-this._container.y, 0, this._overlapSize.y);
        if (this._loop !== 0) {
            newPosX = this._container.x;
            newPosY = this._container.y;
            if (this.loopCheckingCurrent()) {
                this._containerPos.x += this._container.x - newPosX;
                this._containerPos.y += this._container.y - newPosY;
            }
        }
        draggingInst = this;
        this._isHoldAreaDone = true;
        this._dragged = true;
        this.updateScrollBarPos();
        this._updateScrollBarVisible();
        this._owner.event(UIEvent.Scroll);
    }
    _touchEnd() {
        ILaya.stage.off(Event.MOUSE_MOVE, this, this._touchMove);
        ILaya.stage.off(Event.MOUSE_UP, this, this._touchEnd);
        if (draggingInst == this)
            draggingInst = null;
        s_gestureFlag = 0;
        if (!this._dragged || !this._touchEffect) {
            this._dragged = false;
            return;
        }
        this._dragged = false;
        this._tweenStart.setTo(this._container.x, this._container.y);
        s_endPos.setTo(this._tweenStart.x, this._tweenStart.y);
        let flag = false;
        if (this._container.x > 0) {
            s_endPos.x = 0;
            flag = true;
        }
        else if (this._container.x < -this._overlapSize.x) {
            s_endPos.x = -this._overlapSize.x;
            flag = true;
        }
        if (this._container.y > 0) {
            s_endPos.y = 0;
            flag = true;
        }
        else if (this._container.y < -this._overlapSize.y) {
            s_endPos.y = -this._overlapSize.y;
            flag = true;
        }
        if (flag) {
            this._tweenChange.setTo(s_endPos.x - this._tweenStart.x, s_endPos.y - this._tweenStart.y);
            if (this._tweenChange.x < -UIConfig2.touchDragSensitivity || this._tweenChange.y < -UIConfig2.touchDragSensitivity) {
                this._refreshEventDispatching = true;
                this._owner.event(UIEvent.PullDownRelease);
                this._refreshEventDispatching = false;
            }
            else if (this._tweenChange.x > UIConfig2.touchDragSensitivity || this._tweenChange.y > UIConfig2.touchDragSensitivity) {
                this._refreshEventDispatching = true;
                this._owner.event(UIEvent.PullUpRelease);
                this._refreshEventDispatching = false;
            }
            if (this._headerLockedSize > 0 && s_endPos[this._refreshBarAxis] === 0) {
                s_endPos[this._refreshBarAxis] = this._headerLockedSize;
                this._tweenChange.x = s_endPos.x - this._tweenStart.x;
                this._tweenChange.y = s_endPos.y - this._tweenStart.y;
            }
            else if (this._footerLockedSize > 0 && s_endPos[this._refreshBarAxis] === -this._overlapSize[this._refreshBarAxis]) {
                let max = this._overlapSize[this._refreshBarAxis];
                if (max === 0)
                    max = Math.max(this._contentSize[this._refreshBarAxis] + this._footerLockedSize - this._viewSize[this._refreshBarAxis], 0);
                else
                    max += this._footerLockedSize;
                s_endPos[this._refreshBarAxis] = -max;
                this._tweenChange.x = s_endPos.x - this._tweenStart.x;
                this._tweenChange.y = s_endPos.y - this._tweenStart.y;
            }
            this._tweenDuration.setTo(TWEEN_TIME_DEFAULT, TWEEN_TIME_DEFAULT);
        }
        else {
            if (!this._inertiaDisabled) {
                let velocity = DragSupport.computeVelocity(this._slidingPoints);
                this.updateTargetAndDuration(this._tweenStart, velocity, "x", s_endPos, this._tweenDuration);
                this.updateTargetAndDuration(this._tweenStart, velocity, "y", s_endPos, this._tweenDuration);
            }
            else
                this._tweenDuration.setTo(TWEEN_TIME_DEFAULT, TWEEN_TIME_DEFAULT);
            s_oldChange.setTo(s_endPos.x - this._tweenStart.x, s_endPos.y - this._tweenStart.y);
            this.loopCheckingTarget(s_endPos);
            if (this._pageMode || this._snapToItem)
                this.alignPosition(s_endPos, true);
            this._tweenChange.x = s_endPos.x - this._tweenStart.x;
            this._tweenChange.y = s_endPos.y - this._tweenStart.y;
            if (this._tweenChange.x === 0 && this._tweenChange.y === 0) {
                this._updateScrollBarVisible();
                return;
            }
            if (this._pageMode || this._snapToItem) {
                this.fixDuration("x", s_oldChange.x);
                this.fixDuration("y", s_oldChange.y);
            }
        }
        this.startTween(2);
    }
    _mouseWheel(evt) {
        if (this._mouseWheelDisabled)
            return;
        let delta = evt.delta;
        if (this._snapToItem && Math.abs(delta) < 1)
            delta = Math.sign(delta);
        if (this._overlapSize.x > 0 && this._overlapSize.y === 0) {
            let step = this._pageMode ? this._pageSize.x : this._step;
            this.setPosX(this._xPos + step * delta, false);
            evt.stopPropagation();
        }
        else {
            let step = this._pageMode ? this._pageSize.y : this._step;
            this.setPosY(this._yPos + step * delta, false);
            evt.stopPropagation();
        }
    }
    _rollOver() {
        this._hover = true;
        if (this._barDisplay === ScrollBarDisplay.OnScroll || this._barDisplay === ScrollBarDisplay.OnOverflowAndScroll)
            this._updateScrollBarVisible();
    }
    _rollOut() {
        this._hover = false;
        if (this._barDisplay === ScrollBarDisplay.OnScroll || this._barDisplay === ScrollBarDisplay.OnOverflowAndScroll)
            this._updateScrollBarVisible();
    }
    updateScrollBarPos() {
        if (this._vScrollBar)
            this._vScrollBar.setScrollPerc(this._overlapSize.y === 0 ? 0 : MathUtil.clamp(-this._container.y, 0, this._overlapSize.y) / this._overlapSize.y);
        if (this._hScrollBar)
            this._hScrollBar.setScrollPerc(this._overlapSize.x === 0 ? 0 : MathUtil.clamp(-this._container.x, 0, this._overlapSize.x) / this._overlapSize.x);
        this.checkRefreshBar();
    }
    _updateScrollBarVisible() {
        if (this._vScrollBar) {
            if (this._viewSize.y <= this._vScrollBar.minSize || this._vScrollNone)
                this._vScrollBar.visible = false;
            else
                this.updateScrollBarVisible2(this._vScrollBar);
        }
        if (this._hScrollBar) {
            if (this._viewSize.x <= this._hScrollBar.minSize || this._hScrollNone)
                this._hScrollBar.visible = false;
            else
                this.updateScrollBarVisible2(this._hScrollBar);
        }
    }
    updateScrollBarVisible2(bar) {
        let flag = this._barDisplay === ScrollBarDisplay.OnScroll || this._barDisplay === ScrollBarDisplay.OnOverflowAndScroll;
        if (flag)
            Tween.killAll(bar);
        if (flag && !this._hover && this._tweening === 0 && !this._dragged && !bar.gripDragging) {
            if (bar.visible)
                Tween.create(bar).go("alpha", 1, 0).duration(0.5).delay(0.5).then(this._barTweenComplete, this);
        }
        else {
            bar.alpha = 1;
            bar.visible = true;
        }
    }
    _barTweenComplete(tweener) {
        let bar = tweener.target;
        bar.alpha = 1;
        bar.visible = false;
    }
    getLoopPartSize(division, axis) {
        return (this._contentSize[axis] + (axis == "x" ? this._owner.layout.columnGap : this._owner.layout.rowGap)) / division;
    }
    loopCheckingCurrent() {
        let changed = false;
        if (this._loop === 1 && this._overlapSize.x > 0) {
            if (this._xPos < 0.001) {
                this._xPos += this.getLoopPartSize(2, "x");
                changed = true;
            }
            else if (this._xPos >= this._overlapSize.x) {
                this._xPos -= this.getLoopPartSize(2, "x");
                changed = true;
            }
        }
        else if (this._loop === 2 && this._overlapSize.y > 0) {
            if (this._yPos < 0.001) {
                this._yPos += this.getLoopPartSize(2, "y");
                changed = true;
            }
            else if (this._yPos >= this._overlapSize.y) {
                this._yPos -= this.getLoopPartSize(2, "y");
                changed = true;
            }
        }
        if (changed)
            this._container.pos(Math.floor(-this._xPos), Math.floor(-this._yPos));
        return changed;
    }
    loopCheckingTarget(endPos) {
        if (this._loop === 1)
            this.loopCheckingTarget2(endPos, "x");
        if (this._loop === 2)
            this.loopCheckingTarget2(endPos, "y");
    }
    loopCheckingTarget2(endPos, axis) {
        let halfSize;
        let tmp;
        if (endPos[axis] > 0) {
            halfSize = this.getLoopPartSize(2, axis);
            tmp = this._tweenStart[axis] - halfSize;
            if (tmp <= 0 && tmp >= -this._overlapSize[axis]) {
                endPos[axis] -= halfSize;
                this._tweenStart[axis] = tmp;
            }
        }
        else if (endPos[axis] < -this._overlapSize[axis]) {
            halfSize = this.getLoopPartSize(2, axis);
            tmp = this._tweenStart[axis] + halfSize;
            if (tmp <= 0 && tmp >= -this._overlapSize[axis]) {
                endPos[axis] += halfSize;
                this._tweenStart[axis] = tmp;
            }
        }
    }
    loopCheckingNewPos(value, axis) {
        if (this._overlapSize[axis] === 0)
            return value;
        let pos = axis == "x" ? this._xPos : this._yPos;
        let changed = false;
        let v;
        if (value < 0.001) {
            value += this.getLoopPartSize(2, axis);
            if (value > pos) {
                v = this.getLoopPartSize(6, axis);
                v = Math.ceil((value - pos) / v) * v;
                pos = MathUtil.clamp(pos + v, 0, this._overlapSize[axis]);
                changed = true;
            }
        }
        else if (value >= this._overlapSize[axis]) {
            value -= this.getLoopPartSize(2, axis);
            if (value < pos) {
                v = this.getLoopPartSize(6, axis);
                v = Math.ceil((pos - value) / v) * v;
                pos = MathUtil.clamp(pos - v, 0, this._overlapSize[axis]);
                changed = true;
            }
        }
        if (changed) {
            if (axis == "x")
                this._container.x = -Math.floor(pos);
            else
                this._container.y = -Math.floor(pos);
        }
        return value;
    }
    alignPosition(pos, inertialScrolling) {
        if (this._pageMode) {
            pos.x = this.alignByPage(pos.x, "x", inertialScrolling);
            pos.y = this.alignByPage(pos.y, "y", inertialScrolling);
        }
        else if (this._snapToItem) {
            let xDir = 0;
            let yDir = 0;
            if (inertialScrolling) {
                xDir = pos.x - this._containerPos.x;
                yDir = pos.y - this._containerPos.y;
            }
            let pt = this._layout.getSnappingPosition(-pos.x, -pos.y, xDir, yDir, s_Point);
            if (pos.x < 0 && pos.x > -this._overlapSize.x)
                pos.x = -pt.x;
            if (pos.y < 0 && pos.y > -this._overlapSize.y)
                pos.y = -pt.y;
        }
    }
    alignByPage(pos, axis, inertialScrolling) {
        let page;
        if (pos > 0)
            page = 0;
        else if (pos < -this._overlapSize[axis])
            page = Math.ceil(this._contentSize[axis] / this._pageSize[axis]) - 1;
        else {
            page = Math.floor(-pos / this._pageSize[axis]);
            let change = inertialScrolling ? (pos - this._containerPos[axis]) : (pos - this._container[axis]);
            let testPageSize = Math.min(this._pageSize[axis], this._contentSize[axis] - (page + 1) * this._pageSize[axis]);
            let delta = -pos - page * this._pageSize[axis];
            if (Math.abs(change) > this._pageSize[axis]) {
                if (delta > testPageSize * 0.5)
                    page++;
            }
            else {
                if (delta > testPageSize * (change < 0 ? UIConfig2.defaultScrollPagingThreshold : (1 - UIConfig2.defaultScrollPagingThreshold)))
                    page++;
            }
            pos = -page * this._pageSize[axis];
            if (pos < -this._overlapSize[axis])
                pos = -this._overlapSize[axis];
        }
        if (inertialScrolling) {
            let oldPos = this._tweenStart[axis];
            let oldPage;
            if (oldPos > 0)
                oldPage = 0;
            else if (oldPos < -this._overlapSize[axis])
                oldPage = Math.ceil(this._contentSize[axis] / this._pageSize[axis]) - 1;
            else
                oldPage = Math.floor(-oldPos / this._pageSize[axis]);
            let startPage = Math.floor(-this._containerPos[axis] / this._pageSize[axis]);
            if (Math.abs(page - startPage) > 1 && Math.abs(oldPage - startPage) <= 1) {
                if (page > startPage)
                    page = startPage + 1;
                else
                    page = startPage - 1;
                pos = -page * this._pageSize[axis];
            }
        }
        return pos;
    }
    updateTargetAndDuration(start, velocity, axis, outEnd, outDuration) {
        let pos = start[axis];
        let v = velocity[axis];
        if (pos > 0 || this._overlapSize[axis] === 0) {
            outEnd[axis] = 0;
            outDuration[axis] = TWEEN_TIME_DEFAULT;
        }
        else if (pos < -this._overlapSize[axis]) {
            outEnd[axis] = -this._overlapSize[axis];
            outDuration[axis] = TWEEN_TIME_DEFAULT;
        }
        else if (v !== 0) {
            let ratio = UIConfig2.defaultScrollDecelerationRate;
            let tmp = Math.log(ratio);
            let frames = -Math.log(Math.abs(v)) / tmp;
            let n = Math.pow(ratio, frames);
            tmp = ratio * (1 - n) / (1 - ratio);
            let change = v * tmp;
            if (Math.abs(change) <= 1) {
                change = 0;
                frames = 0;
            }
            outEnd[axis] = pos + change;
            outDuration[axis] = frames * 0.0166;
        }
        else {
            outEnd[axis] = pos;
            outDuration[axis] = 0;
        }
    }
    fixDuration(axis, oldChange) {
        if (this._tweenChange[axis] === 0 || Math.abs(this._tweenChange[axis]) >= Math.abs(oldChange)) {
            if (oldChange === 0)
                this._tweenDuration[axis] = TWEEN_TIME_DEFAULT;
            return;
        }
        let newDuration = Math.abs(this._tweenChange[axis] / oldChange) * this._tweenDuration[axis];
        if (newDuration < TWEEN_TIME_DEFAULT)
            newDuration = TWEEN_TIME_DEFAULT;
        this._tweenDuration[axis] = newDuration;
    }
    startTween(type) {
        this._tweenTime.setTo(0, 0);
        this._tweening = type;
        ILaya.timer.frameLoop(1, this, this.tweenUpdate);
        this._updateScrollBarVisible();
    }
    killTween() {
        if (this._tweening === 1) {
            this._container.pos(this._tweenStart.x + this._tweenChange.x, this._tweenStart.y + this._tweenChange.y);
            this._owner.event(UIEvent.Scroll);
        }
        this._tweening = 0;
        ILaya.timer.clear(this, this.tweenUpdate);
        this._updateScrollBarVisible();
        this._owner.event(UIEvent.ScrollEnd);
    }
    checkRefreshBar() {
        if (this._header == null && this._footer == null)
            return;
        let pos = this._container[this._refreshBarAxis];
        if (this._header) {
            if (pos > 0) {
                if (!this._header.parent) {
                    this._maskContainer.addChildAt(this._header, this._maskContainer.getChildIndex(this._container));
                }
                let pt = s_Point;
                pt.setTo(this._header.width, this._header.height);
                pt[this._refreshBarAxis] = pos;
                this._header.size(pt.x, pt.y);
            }
            else {
                this._header.removeSelf();
            }
        }
        if (this._footer) {
            let max = this._overlapSize[this._refreshBarAxis];
            if (pos < -max || max === 0 && this._footerLockedSize > 0) {
                if (!this._footer.parent) {
                    this._maskContainer.addChildAt(this._footer, this._maskContainer.getChildIndex(this._container));
                }
                let pt = s_Point;
                pt.setTo(this._footer.x, this._footer.y);
                if (max > 0)
                    pt[this._refreshBarAxis] = pos + this._contentSize[this._refreshBarAxis];
                else
                    pt[this._refreshBarAxis] = Math.max(Math.min(pos + this._viewSize[this._refreshBarAxis], this._viewSize[this._refreshBarAxis] - this._footerLockedSize), this._viewSize[this._refreshBarAxis] - this._contentSize[this._refreshBarAxis]);
                this._footer.setLeftTop(pt.x, pt.y);
                pt.setTo(this._footer.width, this._footer.height);
                if (max > 0)
                    pt[this._refreshBarAxis] = -max - pos;
                else
                    pt[this._refreshBarAxis] = this._viewSize[this._refreshBarAxis] - this._footer[this._refreshBarAxis];
                this._footer.size(pt.x, pt.y);
            }
            else {
                this._footer.removeSelf();
            }
        }
    }
    tweenUpdate() {
        let nx = this.runTween("x");
        let ny = this.runTween("y");
        this._container.pos(nx, ny);
        if (this._tweening === 2) {
            if (this._overlapSize.x > 0)
                this._xPos = MathUtil.clamp(-nx, 0, this._overlapSize.x);
            if (this._overlapSize.y > 0)
                this._yPos = MathUtil.clamp(-ny, 0, this._overlapSize.y);
        }
        if (this._tweenChange.x === 0 && this._tweenChange.y === 0) {
            this._tweening = 0;
            ILaya.timer.clear(this, this.tweenUpdate);
            this.loopCheckingCurrent();
            this.updateScrollBarPos();
            this._updateScrollBarVisible();
            this._owner.event(UIEvent.Scroll);
            this._owner.event(UIEvent.ScrollEnd);
        }
        else {
            this.updateScrollBarPos();
            this._owner.event(UIEvent.Scroll);
        }
    }
    runTween(axis) {
        let newValue;
        if (this._tweenChange[axis] !== 0) {
            this._tweenTime[axis] += ILaya.timer.delta / 1000;
            if (this._tweenTime[axis] >= this._tweenDuration[axis]) {
                newValue = this._tweenStart[axis] + this._tweenChange[axis];
                this._tweenChange[axis] = 0;
            }
            else {
                let ratio = easeFunc(this._tweenTime[axis], this._tweenDuration[axis]);
                newValue = this._tweenStart[axis] + Math.floor(this._tweenChange[axis] * ratio);
            }
            let threshold1 = 0;
            let threshold2 = -this._overlapSize[axis];
            if (this._headerLockedSize > 0 && this._refreshBarAxis === axis)
                threshold1 = this._headerLockedSize;
            if (this._footerLockedSize > 0 && this._refreshBarAxis === axis) {
                let max = this._overlapSize[this._refreshBarAxis];
                if (max === 0)
                    max = Math.max(this._contentSize[this._refreshBarAxis] + this._footerLockedSize - this._viewSize[this._refreshBarAxis], 0);
                else
                    max += this._footerLockedSize;
                threshold2 = -max;
            }
            if (this._tweening === 2 && this._bouncebackEffect) {
                if (newValue > 20 + threshold1 && this._tweenChange[axis] > 0
                    || newValue > threshold1 && this._tweenChange[axis] === 0) {
                    this._tweenTime[axis] = 0;
                    this._tweenDuration[axis] = TWEEN_TIME_DEFAULT;
                    this._tweenChange[axis] = -newValue + threshold1;
                    this._tweenStart[axis] = newValue;
                }
                else if (newValue < threshold2 - 20 && this._tweenChange[axis] < 0
                    || newValue < threshold2 && this._tweenChange[axis] === 0) {
                    this._tweenTime[axis] = 0;
                    this._tweenDuration[axis] = TWEEN_TIME_DEFAULT;
                    this._tweenChange[axis] = threshold2 - newValue;
                    this._tweenStart[axis] = newValue;
                }
            }
            else {
                if (newValue > threshold1) {
                    newValue = threshold1;
                    this._tweenChange[axis] = 0;
                }
                else if (newValue < threshold2) {
                    newValue = threshold2;
                    this._tweenChange[axis] = 0;
                }
            }
        }
        else
            newValue = this._container[axis];
        return newValue;
    }
}
function easeFunc(t, d) {
    return (t = t / d - 1) * t * t + 1;
}
